export default __webpack_public_path__ + "static/2-05ba7e578a3f6eefe97b358f02aacdf5.png";